import React, { FC } from 'react';
import styled from 'styled-components';
import { ContainerBase } from 'src/components/widgets/layouts';
import { SkeletonBlock, SkeletonStack } from 'src/components/widgets/skeleton';

// Mirrors the shared FiltersRow the page renders (same gap and bottom margin).
const FiltersRow = styled.div`
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    flex-wrap: wrap;
`;

const TableBox = styled.div`
    border: 1px solid #dbe2e6;
    border-radius: 0.25rem;
    overflow: hidden;
`;

const TableRow = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 0.75rem 1rem;
    border-top: 1px solid #dbe2e6;

    &:first-child {
        border-top: none;
    }
`;

export const ProjectsListSkeleton: FC = () => (
    <TableBox>
        <TableRow>
            <SkeletonBlock $width='100%' $height='14px' />
        </TableRow>
        {Array.from({ length: 8 }).map((_, index) => (
            <TableRow key={index}>
                <SkeletonBlock $width='64px' $height='48px' $radius='4px' />
                <SkeletonBlock $width='22%' $height='14px' />
                <SkeletonBlock $width='12%' $height='14px' />
                <SkeletonBlock $width='14%' $height='14px' />
                <SkeletonBlock $width='14%' $height='14px' />
                <SkeletonBlock $width='14%' $height='14px' />
            </TableRow>
        ))}
    </TableBox>
);

export const DamProjectsListingPageSkeleton: FC = () => (
    <ContainerBase>
        <SkeletonStack $gap='10px' $margin='0 0 24px'>
            <SkeletonBlock $width='140px' $height='28px' />
            <SkeletonBlock $width='50%' $height='14px' />
        </SkeletonStack>
        <FiltersRow>
            <SkeletonBlock $width='90px' $height='32px' $radius='6px' />
            <SkeletonBlock $width='110px' $height='32px' $radius='6px' />
            <SkeletonBlock $width='300px' $height='32px' $radius='6px' />
        </FiltersRow>
        <ProjectsListSkeleton />
    </ContainerBase>
);

const DetailLayout = styled.div`
    display: grid;
    grid-template-columns: auto min(38rem, 43%) 3rem;
    gap: 0;
    height: calc(100vh - 11.4375rem);
`;

const DetailPanel = styled.div`
    border: 1px solid #dbe2e6;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const DamProjectsDetailPageSkeleton: FC = () => (
    <ContainerBase>
        <SkeletonStack $gap='10px' $margin='0 0 20px'>
            <SkeletonBlock $width='240px' $height='28px' />
        </SkeletonStack>
        <DetailLayout>
            <DetailPanel style={{ marginRight: '1rem' }}>
                <SkeletonBlock $width='100%' $height='100%' />
            </DetailPanel>
            <DetailPanel>
                <SkeletonBlock $width='60%' $height='20px' />
                <SkeletonBlock $width='100%' $height='14px' />
                <SkeletonBlock $width='100%' $height='14px' />
                <SkeletonBlock $width='80%' $height='14px' />
                <SkeletonBlock $width='100%' $height='120px' $radius='6px' />
            </DetailPanel>
            <DetailPanel style={{ alignItems: 'center', gap: '20px' }}>
                {Array.from({ length: 4 }).map((_, index) => (
                    <SkeletonBlock key={index} $width='22px' $height='22px' $radius='4px' />
                ))}
            </DetailPanel>
        </DetailLayout>
    </ContainerBase>
);

export default DamProjectsListingPageSkeleton;
